import basic from './basic';
import bidding from './bidding';
import binForm from './bin-form';
import cartCheckout from './cart-checkout';
import cartOverview from './cart-overview';
import cartPaypalPayment from './cart-paypal-payment';
import categoryList from './category-list';
import checkoutSelectPayment from './checkout-select-payment';
import checkout2 from './checkout2';
import customResults from './custom-results';
import detailedSearch from './detailed-search';
import klarnaPin from './klarna-pin';
import klarnaSignup from './klarna-signup';
import memberSearch from './member-search';
import messages from './messages';
import profile from './profile';
import startPage from './start-page';
import viewItem from './view-item';
import logger from 'logger';


const loadModules = {
    'basic': basic,
    'bidding': bidding,
    'bin-form': binForm,
    'cart-checkout': cartCheckout,
    'cart-overview': cartOverview,
    'cart-paypal-payment': cartPaypalPayment,
    'category-list': categoryList,
    'category': System.import('./category'),
    'checkout-select-payment': checkoutSelectPayment,
    'checkout2': checkout2,
    'custom-results': customResults,
    'detailed-search': detailedSearch,
    'klarna-pin': klarnaPin,
    'klarna-signup': klarnaSignup,
    'member-search': memberSearch,
    'messages': messages,
    'profile': profile,
    'search-results': System.import('./search-results'),
    'start-page': startPage,
    'view-item': viewItem
};

export default initData => {
    let module = '';

    if (initData.selfLoadingModule) {
        module = loadModules['basic'];
    } else {
        const mod = initData.module.split('/');
        console.log('Module ====== : ' + mod[4]);
        module = loadModules[mod[4]];
    };

    try {
        if (typeof module === 'function') {
            module(initData);
        } else {
            module
                .then(module => module(initData))
                .catch(error => {
                    logger(error)
                });
        }
    } catch (e) {
        logger(e);
    };
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/load-modules.js